<template>
    <v-card flat class="sub-site-wrapper">
        <div class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12">
                    <email-connections-types v-if="emailConnections" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <email-connections-is-standard v-if="emailConnections" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <email-connections-past-30-days v-if="emailConnections" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import EmailConnectionsIsStandard from '../charts/EmailConnectionsIsStandard.vue';
import EmailConnectionsPast30Days from '../charts/EmailConnectionsPast30Days.vue';
import EmailConnectionsTypes from '../charts/EmailConnectionsTypes.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        EmailConnectionsIsStandard,
        EmailConnectionsPast30Days,
        EmailConnectionsTypes
    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['emailConnections', 'loading', 'statisticsAge'])
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped></style>